import { gql } from '@apollo/client'

export const BOOK_DOLPHIN_APPOINTMENT = gql`
  mutation BookDolphinAppointment(
    $datetime: NaiveDateTime!
    $locationId: ID!
    $partnerId: ID
    $patient: DolphinPatientInput!
    $billingParty: DolphinBillingPartyInput!
    $referrer: String!
    $source: String
    $attributionData: AttributionDataInput
  ) {
    bookDolphinAppointment(
      datetime: $datetime
      locationId: $locationId
      partnerId: $partnerId
      patient: $patient
      billingParty: $billingParty
      referrer: $referrer
      source: $source
      attributionData: $attributionData
    ) {
      ... on DolphinBookingIntent {
        id
        start
      }
      ... on UserInputValidationFailed {
        fieldErrors {
          errors {
            field
            message
          }
          field
          message
        }
      }
      ... on AppointmentLimitReached {
        message
      }
      ... on ReservationUnavailable {
        message
      }
    }
  }
`
